'use client';

import { useState, useEffect } from 'react';
import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

interface GalleryItem {
  id: string;
  project: string;
  category: string;
  image: string;
  alt: string;
}

const galleryItems: GalleryItem[] = [
{
  id: 'port_1',
  project: 'Sophia & Michael',
  category: 'Weddings',
  image: "https://images.unsplash.com/photo-1601327089341-c06e8d652581",
  alt: 'Bride in elegant lace gown holding pink rose bouquet at garden wedding ceremony'
},
{
  id: 'port_2',
  project: 'Emma Portrait',
  category: 'Portraits',
  image: "https://images.unsplash.com/photo-1630520901951-707090ccac66",
  alt: 'Young woman with natural makeup in denim jacket against white brick wall'
},
{
  id: 'port_3',
  project: 'TechCorp Gala',
  category: 'Events',
  image: "https://images.unsplash.com/photo-1734211022602-79ecb2935c4d",
  alt: 'Corporate gala attendees networking under crystal chandelier with golden lighting'
},
{
  id: 'port_4',
  project: 'Luxury Watch',
  category: 'Commercial',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1f3519791-1765335465779.png",
  alt: 'High-end watch on marble surface with dramatic side lighting and reflections'
},
{
  id: 'port_5',
  project: 'Fashion Editorial',
  category: 'Fashion',
  image: "https://images.unsplash.com/photo-1545095617-bafd634913d2",
  alt: 'Model in designer black evening gown on urban rooftop with city skyline'
},
{
  id: 'port_6',
  project: 'Beach Wedding',
  category: 'Weddings',
  image: "https://images.unsplash.com/photo-1598871244392-76f6d0ab08f5",
  alt: 'Couple walking barefoot on sandy beach at sunset with ocean waves'
},
{
  id: 'port_7',
  project: 'Family Portrait',
  category: 'Portraits',
  image: "https://images.unsplash.com/photo-1690391778855-fddecaed59cd",
  alt: 'Happy family of four sitting on grass in park with autumn leaves'
},
{
  id: 'port_8',
  project: 'Charity Event',
  category: 'Events',
  image: "https://images.unsplash.com/photo-1637404893433-3360bf766561",
  alt: 'Elegant ballroom event with guests in formal attire and floral centerpieces'
},
{
  id: 'port_9',
  project: 'Perfume Campaign',
  category: 'Commercial',
  image: "https://images.unsplash.com/photo-1727060798714-a1006106f3f8",
  alt: 'Luxury perfume bottle on reflective surface with soft pink background lighting'
},
{
  id: 'port_10',
  project: 'Street Fashion',
  category: 'Fashion',
  image: "https://images.unsplash.com/photo-1670908655073-26874baf391c",
  alt: 'Fashion model in trendy streetwear posing against colorful graffiti wall'
},
{
  id: 'port_11',
  project: 'Garden Wedding',
  category: 'Weddings',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_147c596c8-1766130277188.png",
  alt: 'First dance under string lights at outdoor garden wedding reception'
},
{
  id: 'port_12',
  project: 'Senior Portrait',
  category: 'Portraits',
  image: "https://images.unsplash.com/photo-1447244801698-85efc0fd30da",
  alt: 'Young woman in flowing white dress standing in sunlit wildflower field'
},
{
  id: 'port_13',
  project: 'Conference',
  category: 'Events',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1b90306fa-1767355960278.png",
  alt: 'Business professionals collaborating at modern conference table with laptops'
},
{
  id: 'port_14',
  project: 'Jewelry Ad',
  category: 'Commercial',
  image: "https://images.unsplash.com/photo-1510936353762-b95643f49856",
  alt: 'Diamond necklace on black velvet with dramatic spotlight creating sparkle'
},
{
  id: 'port_15',
  project: 'Runway Show',
  category: 'Fashion',
  image: "https://images.unsplash.com/photo-1571924849183-a68a3879348d",
  alt: 'Model walking fashion runway in designer gown with dramatic lighting'
},
{
  id: 'port_16',
  project: 'Vineyard Wedding',
  category: 'Weddings',
  image: "https://images.unsplash.com/photo-1699942696746-1de325aaad68",
  alt: 'Couple kissing in vineyard rows during golden hour with mountains background'
},
{
  id: 'port_17',
  project: 'Maternity',
  category: 'Portraits',
  image: "https://images.unsplash.com/photo-1663331336176-f6244ba0b25a",
  alt: 'Pregnant woman in flowing dress cradling belly in sunlit studio'
},
{
  id: 'port_18',
  project: 'Product Launch',
  category: 'Events',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_18c6060ca-1766265672120.png",
  alt: 'Tech product launch event with attendees viewing new gadget display'
},
{
  id: 'port_19',
  project: 'Watch Campaign',
  category: 'Commercial',
  image: "https://images.unsplash.com/photo-1664018899956-e45c5729c539",
  alt: 'Luxury wristwatch on leather strap with moody dark background'
},
{
  id: 'port_20',
  project: 'Haute Couture',
  category: 'Fashion',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1f7ab4c16-1766922250432.png",
  alt: 'Model in haute couture gown with dramatic makeup and elaborate hairstyle'
},
{
  id: 'port_21',
  project: 'Rustic Wedding',
  category: 'Weddings',
  image: "https://images.unsplash.com/photo-1607128294869-93c7fcd03dbd",
  alt: 'Barn wedding reception with string lights and guests dancing on wooden floor'
},
{
  id: 'port_22',
  project: 'Couple Session',
  category: 'Portraits',
  image: "https://images.unsplash.com/photo-1596474971295-65d4f8963dcf",
  alt: 'Couple embracing on beach at sunset with golden light reflecting on water'
},
{
  id: 'port_23',
  project: 'Awards Ceremony',
  category: 'Events',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_126743316-1768291180239.png",
  alt: 'Award winner giving speech on stage with trophy and spotlights'
},
{
  id: 'port_24',
  project: 'Cosmetics Ad',
  category: 'Commercial',
  image: "https://images.unsplash.com/photo-1671155029278-84891edf0a19",
  alt: 'Luxury makeup products arranged on marble with soft pink lighting'
}];


export default function PortfolioGallery() {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState(0);
  const [visibleItems, setVisibleItems] = useState(12);

  const openLightbox = (index: number) => {
    setCurrentImage(index);
    setLightboxOpen(true);
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
  };

  const nextImage = () => {
    setCurrentImage((prev) => (prev + 1) % galleryItems.length);
  };

  const prevImage = () => {
    setCurrentImage((prev) => (prev - 1 + galleryItems.length) % galleryItems.length);
  };

  const loadMore = () => {
    setVisibleItems((prev) => Math.min(prev + 12, galleryItems.length));
  };

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (!lightboxOpen) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft') prevImage();
      if (e.key === 'ArrowRight') nextImage();
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [lightboxOpen]);

  return (
    <>
      <section data-component-id="src/app/portfolio/components/PortfolioGallery.tsx:226:6" data-component-path="src/app/portfolio/components/PortfolioGallery.tsx" data-component-line="226" data-component-end-line="260" data-component-file="PortfolioGallery.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22className%22%3A%22px-6%20md%3Apx-12%20max-w-container%20mx-auto%20mb-20%22%7D" className="px-6 md:px-12 max-w-container mx-auto mb-20">
        {/* Masonry Grid */}
        <div data-component-id="src/app/portfolio/components/PortfolioGallery.tsx:228:8" data-component-path="src/app/portfolio/components/PortfolioGallery.tsx" data-component-line="228" data-component-end-line="247" data-component-file="PortfolioGallery.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-1%20md%3Agrid-cols-2%20lg%3Agrid-cols-3%20gap-4%22%7D" className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {galleryItems.slice(0, visibleItems).map((item, index) =>
          <div data-component-id="src/app/portfolio/components/PortfolioGallery.tsx:230:10" data-component-path="src/app/portfolio/components/PortfolioGallery.tsx" data-component-line="230" data-component-end-line="245" data-component-file="PortfolioGallery.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22relative%20group%20overflow-hidden%20rounded-2xl%20cursor-pointer%20aspect-square%22%7D"
            key={item.id}
            className="relative group overflow-hidden rounded-2xl cursor-pointer aspect-square"
            onClick={() => openLightbox(index)}>

              <AppImage data-component-id="src/app/portfolio/components/PortfolioGallery.tsx:235:14" data-component-path="src/app/portfolio/components/PortfolioGallery.tsx" data-component-line="235" data-component-end-line="238" data-component-file="PortfolioGallery.tsx" data-component-name="AppImage" data-component-content="%7B%22elementName%22%3A%22AppImage%22%2C%22className%22%3A%22w-full%20h-full%20object-cover%20group-hover%3Ascale-105%20transition-transform%20duration-500%22%7D"
              src={item.image}
              alt={item.alt}
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />

              <div data-component-id="src/app/portfolio/components/PortfolioGallery.tsx:240:14" data-component-path="src/app/portfolio/components/PortfolioGallery.tsx" data-component-line="240" data-component-end-line="240" data-component-file="PortfolioGallery.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20inset-0%20bg-gradient-to-t%20from-black%2F60%20to-transparent%20opacity-0%20group-hover%3Aopacity-100%20transition-opacity%20duration-300%22%7D" className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              <div data-component-id="src/app/portfolio/components/PortfolioGallery.tsx:241:14" data-component-path="src/app/portfolio/components/PortfolioGallery.tsx" data-component-line="241" data-component-end-line="244" data-component-file="PortfolioGallery.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20bottom-6%20left-6%20opacity-0%20group-hover%3Aopacity-100%20transition-opacity%20duration-300%22%7D" className="absolute bottom-6 left-6 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <p data-component-id="src/app/portfolio/components/PortfolioGallery.tsx:242:16" data-component-path="src/app/portfolio/components/PortfolioGallery.tsx" data-component-line="242" data-component-end-line="242" data-component-file="PortfolioGallery.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-sm%20text-white%2F80%20mb-1%22%7D" className="text-sm text-white/80 mb-1">{item.category}</p>
                <h3 data-component-id="src/app/portfolio/components/PortfolioGallery.tsx:243:16" data-component-path="src/app/portfolio/components/PortfolioGallery.tsx" data-component-line="243" data-component-end-line="243" data-component-file="PortfolioGallery.tsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%2C%22className%22%3A%22text-xl%20font-serif%20font-semibold%20text-white%22%7D" className="text-xl font-serif font-semibold text-white">{item.project}</h3>
              </div>
            </div>
          )}
        </div>

        {/* Load More Button */}
        {visibleItems < galleryItems.length &&
        <div data-component-id="src/app/portfolio/components/PortfolioGallery.tsx:251:8" data-component-path="src/app/portfolio/components/PortfolioGallery.tsx" data-component-line="251" data-component-end-line="258" data-component-file="PortfolioGallery.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22text-center%20mt-12%22%7D" className="text-center mt-12">
            <button data-component-id="src/app/portfolio/components/PortfolioGallery.tsx:252:12" data-component-path="src/app/portfolio/components/PortfolioGallery.tsx" data-component-line="252" data-component-end-line="257" data-component-file="PortfolioGallery.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22px-8%20py-3.5%20bg-white%2F5%20hover%3Abg-white%2F10%20text-foreground%20rounded-full%20font-semibold%20transition-all%20duration-300%20border%20border-border%22%2C%22textContent%22%3A%22Load%20More%22%7D"
            onClick={loadMore}
            className="px-8 py-3.5 bg-white/5 hover:bg-white/10 text-foreground rounded-full font-semibold transition-all duration-300 border border-border">

              Load More
            </button>
          </div>
        }
      </section>

      {/* Lightbox */}
      {lightboxOpen &&
      <div data-component-id="src/app/portfolio/components/PortfolioGallery.tsx:264:6" data-component-path="src/app/portfolio/components/PortfolioGallery.tsx" data-component-line="264" data-component-end-line="302" data-component-file="PortfolioGallery.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22fixed%20inset-0%20z-50%20bg-black%2F95%20flex%20items-center%20justify-center%20p-4%22%7D" className="fixed inset-0 z-50 bg-black/95 flex items-center justify-center p-4">
          <button data-component-id="src/app/portfolio/components/PortfolioGallery.tsx:265:10" data-component-path="src/app/portfolio/components/PortfolioGallery.tsx" data-component-line="265" data-component-end-line="271" data-component-file="PortfolioGallery.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22absolute%20top-6%20right-6%20w-12%20h-12%20rounded-full%20bg-white%2F10%20hover%3Abg-white%2F20%20flex%20items-center%20justify-center%20transition-all%22%7D"
          onClick={closeLightbox}
          className="absolute top-6 right-6 w-12 h-12 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-all"
          aria-label="Close lightbox">

            <Icon data-component-id="src/app/portfolio/components/PortfolioGallery.tsx:270:12" data-component-path="src/app/portfolio/components/PortfolioGallery.tsx" data-component-line="270" data-component-end-line="270" data-component-file="PortfolioGallery.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22XMarkIcon%22%2C%22className%22%3A%22text-white%22%7D" name="XMarkIcon" size={24} className="text-white" />
          </button>

          <button data-component-id="src/app/portfolio/components/PortfolioGallery.tsx:273:10" data-component-path="src/app/portfolio/components/PortfolioGallery.tsx" data-component-line="273" data-component-end-line="279" data-component-file="PortfolioGallery.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22absolute%20left-6%20w-12%20h-12%20rounded-full%20bg-white%2F10%20hover%3Abg-white%2F20%20flex%20items-center%20justify-center%20transition-all%22%7D"
          onClick={prevImage}
          className="absolute left-6 w-12 h-12 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-all"
          aria-label="Previous image">

            <Icon data-component-id="src/app/portfolio/components/PortfolioGallery.tsx:278:12" data-component-path="src/app/portfolio/components/PortfolioGallery.tsx" data-component-line="278" data-component-end-line="278" data-component-file="PortfolioGallery.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22ChevronLeftIcon%22%2C%22className%22%3A%22text-white%22%7D" name="ChevronLeftIcon" size={24} className="text-white" />
          </button>

          <div data-component-id="src/app/portfolio/components/PortfolioGallery.tsx:281:10" data-component-path="src/app/portfolio/components/PortfolioGallery.tsx" data-component-line="281" data-component-end-line="293" data-component-file="PortfolioGallery.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22max-w-5xl%20w-full%22%7D" className="max-w-5xl w-full">
            <AppImage data-component-id="src/app/portfolio/components/PortfolioGallery.tsx:282:12" data-component-path="src/app/portfolio/components/PortfolioGallery.tsx" data-component-line="282" data-component-end-line="285" data-component-file="PortfolioGallery.tsx" data-component-name="AppImage" data-component-content="%7B%22elementName%22%3A%22AppImage%22%2C%22className%22%3A%22w-full%20h-auto%20rounded-2xl%22%7D"
            src={galleryItems[currentImage].image}
            alt={galleryItems[currentImage].alt}
            className="w-full h-auto rounded-2xl" />

            <div data-component-id="src/app/portfolio/components/PortfolioGallery.tsx:287:12" data-component-path="src/app/portfolio/components/PortfolioGallery.tsx" data-component-line="287" data-component-end-line="292" data-component-file="PortfolioGallery.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22mt-6%20text-center%22%7D" className="mt-6 text-center">
              <p data-component-id="src/app/portfolio/components/PortfolioGallery.tsx:288:14" data-component-path="src/app/portfolio/components/PortfolioGallery.tsx" data-component-line="288" data-component-end-line="288" data-component-file="PortfolioGallery.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-sm%20text-white%2F60%22%7D" className="text-sm text-white/60">{galleryItems[currentImage].category}</p>
              <h3 data-component-id="src/app/portfolio/components/PortfolioGallery.tsx:289:14" data-component-path="src/app/portfolio/components/PortfolioGallery.tsx" data-component-line="289" data-component-end-line="291" data-component-file="PortfolioGallery.tsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%2C%22className%22%3A%22text-2xl%20font-serif%20font-semibold%20text-white%22%7D" className="text-2xl font-serif font-semibold text-white">
                {galleryItems[currentImage].project}
              </h3>
            </div>
          </div>

          <button data-component-id="src/app/portfolio/components/PortfolioGallery.tsx:295:10" data-component-path="src/app/portfolio/components/PortfolioGallery.tsx" data-component-line="295" data-component-end-line="301" data-component-file="PortfolioGallery.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22absolute%20right-6%20w-12%20h-12%20rounded-full%20bg-white%2F10%20hover%3Abg-white%2F20%20flex%20items-center%20justify-center%20transition-all%22%7D"
          onClick={nextImage}
          className="absolute right-6 w-12 h-12 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-all"
          aria-label="Next image">

            <Icon data-component-id="src/app/portfolio/components/PortfolioGallery.tsx:300:12" data-component-path="src/app/portfolio/components/PortfolioGallery.tsx" data-component-line="300" data-component-end-line="300" data-component-file="PortfolioGallery.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22ChevronRightIcon%22%2C%22className%22%3A%22text-white%22%7D" name="ChevronRightIcon" size={24} className="text-white" />
          </button>
        </div>
      }
    </>);

}